export const DndTypes = {
    JOBPARAMETER: 'jobParameter',
  }